import React, { useState, useEffect } from 'react';
import { TotalData, HoldingsTabKeyNames } from '../../index.type';
import { extractNumber, times100 } from '@/lib/utils';
interface HoldingsConcentrationProps {
  selectedMetrics: {
    holdingsConcentration?: boolean;
    [key: string]: boolean | undefined;
  };
  totalData: Pick<TotalData, HoldingsTabKeyNames>;
}

const HoldingsConcentration: React.FC<HoldingsConcentrationProps> = ({
  selectedMetrics,
  totalData
}) => {
  const [currentSelectedMetrics, setCurrentSelectedMetrics] = useState<{
    holdingsConcentration?: boolean;
    [key: string]: boolean | undefined;
  }>({});

  useEffect(() => {
    setCurrentSelectedMetrics(selectedMetrics);
  }, [selectedMetrics]);

  const handleCheckboxChange = (checked: boolean) => {
    setCurrentSelectedMetrics(prev => ({
      ...prev,
      holdingsConcentration: checked
    }));
  };

  return (
    <div className="border border-[#F0F0F0] rounded-lg p-3 my-4">
      {/* 标题和复选框 */}
      <div className="flex items-center gap-2 mb-4">
        <input
          type="checkbox"
          checked={currentSelectedMetrics.holdingsConcentration || false}
          onChange={e => handleCheckboxChange(e.target.checked)}
          className="w-4 h-4"
        />
        <span className="text-base font-semibold text-[#1F1F1F]">持仓集中度</span>
      </div>

      {/* 统计信息 */}
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <span className="text-xs text-[#1F1F1F]">前5大持仓占比</span>
          <span className="text-base font-semibold text-[#1F1F1F]">
            <span>
              {times100(extractNumber(totalData.top5_holding_ratio.toString())).toString()}
            </span>
            <span className="text-xs font-normal">%</span>
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-xs text-[#1F1F1F]">前10大持仓占比</span>
          <span className="text-base font-semibold text-[#1F1F1F]">
            <span>
              {times100(extractNumber(totalData.top10_holding_ratio.toString())).toString()}
            </span>
            <span className="text-xs font-normal">%</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default HoldingsConcentration;
